/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ResolverConfigurationDirective from './resolver-configuration.directive';

export default angular.module('tektelic.resolverConfiguration', [])
    .directive('tkResolverConfiguration', ResolverConfigurationDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/resolver-configuration/index.js